import { GetConfigUrlFn } from '../Device/Configuration/deviceConfigurationHelper';

const PING = '/ping';

export async function isOnline(getConfigUrl: GetConfigUrlFn) {
	try {
		const configUrl = await getConfigUrl();
		const pingUrl = configUrl + PING;

		return Promise.race([
			fetch(pingUrl, { method: 'HEAD', mode: 'no-cors' })
				.then(() => true)
				.catch(() => false),
			new Promise<boolean>((resolve) => setTimeout(() => resolve(false), 2000)),
		]);
	} catch (e) {
		return false;
	}
}
